<div class="editor-wrapper"
    [ngClass]="{'invalid': customGreetingControl.value?.length > 250 || isLegalDisclaimerEnabled && !customGreetingControl?.value?.includes(':legal_disclaimer')}">
    <!-- <div id=" editor"></div> -->
    <quill-editor [modules]="editorModules" [(ngModel)]="customGreeting" #editor [formats]="formats" class="d-block"
        (onContentChanged)="onContentChanged()"></quill-editor>
    <span class="character-counter" [ngClass]="{'invalid': customGreetingControl.value?.length > 250}">{{
        customGreetingControl.value?.length || 0 }} / {{ 250 }}</span>
</div>
<rosie-validation-error [show]="customGreetingControl?.errors?.maxlength"
    [translationAttributes]="{value: 'Custom greeting', length: 250}"
    [translationKey]="'COMMON.VALIDATION.MAX_LENGTH'"></rosie-validation-error>
<rosie-validation-error
    [show]="isLegalDisclaimerEnabled && !customGreetingControl?.value?.includes(':legal_disclaimer')"
    [translationAttributes]="{value: 'Legal Disclaimer'}"
    [translationKey]="'GREETING.LEGAL_DISCLAIMER_REQUIRED'"></rosie-validation-error>